import React from 'react';
import clsx from 'clsx';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const ChartsSwitcherLoader = () => {
  return /*#__PURE__*/_jsx("ul", {
    className: styles.list,
    children: Array.from({
      length: 12
    }).map((_, idx) => {
      return /*#__PURE__*/_jsx("li", {
        className: clsx(styles.item, styles['item--loading']),
        children: /*#__PURE__*/_jsx("button", {
          type: "button",
          disabled: true,
          className: styles.icon
        })
      }, `charts-${idx}`);
    })
  });
};

export default ChartsSwitcherLoader;